.messgeBody {
  font-size: 16px;
  font-weight: 500;
  margin: 24px 0;
  width: 335px;
}